import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadCustomerLedgerReportPdf = (reportData, companyName, logo, setOpenBackdrop) => {
    if (!reportData || reportData.length === 0) {
        alert("No data found to generate report!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        let currentY = 15;
        const pageWidth = doc.internal.pageSize.getWidth();

        // --- 1. Header Section ---
        if (logo) {
            doc.addImage(logo, 'PNG', 14, 8, 12, 12);
        }

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.setFont("helvetica", "normal");
        doc.text(companyName || 'COMPANY NAME', logo ? 28 : 14, 16);
        
        doc.setFontSize(16);
        doc.setTextColor(25, 118, 210);
        doc.setFont("helvetica", "bold");
        const title = 'Site Stock Report';
        doc.text(title, (pageWidth - doc.getTextWidth(title)) / 2, 26);

        doc.setDrawColor(200);
        doc.line(14, 30, 196, 30);
        
        currentY = 40;

        // Iterate through each Customer
        reportData.forEach((customer) => {
            if (currentY > 250) {
                doc.addPage();
                currentY = 20;
            }

            // Customer Info Box
            doc.setFillColor(245, 247, 250);
            doc.rect(14, currentY, 182, 10, 'F');
            doc.setFontSize(11);
            doc.setTextColor(0);
            doc.setFont("helvetica", "bold");
            doc.text(`Customer: ${customer.customer_name}`, 18, currentY + 7);
            
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.text(`Address: ${customer.customer_address || 'N/A'}`, 192, currentY + 7, { align: 'right' });
            
            currentY += 14;

            // Items Table
            const tableHeaders = [['S.No', 'Item Name', 'Unit', 'Opening', 'InWard', 'OutWard', 'Total Qty']];
            const tableData = (customer.items || []).map((item, idx) => [
                idx + 1,
                item.item_name,
                item.item_unit,
                item.opening_qty,
                item.challan_qty,
                item.credit_qty,
                { content: item.total_qty, styles: { fontStyle: 'bold', textColor: item.total_qty < 0 ? [200, 0, 0] : [0, 100, 0] } }
            ]);

            doc.autoTable({
                startY: currentY,
                head: tableHeaders,
                body: tableData,
                theme: 'grid',
                headStyles: { fillColor: [60, 60, 60], fontSize: 9, halign: 'center' },
                styles: { fontSize: 8, cellPadding: 2 },
                columnStyles: {
                    0: { cellWidth: 10, halign: 'center' },
                    1: { cellWidth: 55 },
                    2: { halign: 'center' },
                    3: { halign: 'center' },
                    4: { halign: 'center' },
                    5: { halign: 'center' },
                    6: { halign: 'center' },
                },
                margin: { left: 14, right: 14 },
            });

            currentY = doc.lastAutoTable.finalY + 15;
        });

        // Footer
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(150);
            doc.text(`Page ${i} of ${totalPages} | Generated on ${new Date().toLocaleString()}`, pageWidth / 2, 290, { align: 'center' });
        }

        doc.save(`Stock_Ledger_${new Date().getTime()}.pdf`);

    } catch (error) {
        console.error("PDF Error:", error);
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadCustomerLedgerReportPdf;